import { memo } from 'react';

interface TimePickerSelectProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  placeholder?: string;
  className?: string;
}

export const TimePickerSelect = memo(function TimePickerSelect({
  value,
  onChange,
  disabled = false,
  placeholder = "시간 선택",
  className = ""
}: TimePickerSelectProps) {
  // 15분 단위로 시간 옵션 생성 (00:00 ~ 23:45)
  const generateTimeOptions = () => {
    const options = [];
    for (let hour = 0; hour < 24; hour++) {
      for (let minute = 0; minute < 60; minute += 15) {
        const timeString = `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`;
        options.push(timeString);
      }
    }
    return options;
  };

  const timeOptions = generateTimeOptions();

  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      className={`h-[30px] px-3 text-base bg-[#F5F5F5] border-[1.5px] border-[#51C854] rounded-lg focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed ${className}`}
    >
      <option value="">{placeholder}</option>
      {timeOptions.map((time) => (
        <option key={time} value={time}>
          {time}
        </option>
      ))}
    </select>
  );
});